import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import OnlineOrderPage from "./OnlineOrderPage";
import OrderStepsProvider from "../../services/context/OrderStepsContext";
import UpdateOrderPage from "./UpdateOrderPage";
import OrderCreatedScreen from "./OrderCreatedScreen";
import useFeatureFlags from "../../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import { useEffect } from "react";
import dataConstants from "../../constants/dataConstants";

function OrderPageRoutes(): JSX.Element {
  const match = useRouteMatch();

  const { isSectionActive } = useFeatureFlags();
  const history = useHistory();

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.TEST_ORDERS)) {
      history.push('/unauthorized')
    }
  }, [])

  return (
    <OrderStepsProvider>
      <Switch>
        <Route exact path={match.path} component={OnlineOrderPage} />
        <Route path={`${match.path}/order-created`} component={OrderCreatedScreen} />
        <Route path={`${match.path}/:id`} component={UpdateOrderPage} />
      </Switch>
    </OrderStepsProvider>
  );
}

export default OrderPageRoutes;
